export const APPLY_FILTERS = 'APPLY_FILTERS';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const SET_ITEMS = 'SET_ITEMS';
export const RESET = 'RESET';
export const SET_TARGETING_CLIENT = 'SET_TARGETING_CLIENT';
export const SET_CLIENTS_DUE_CONTRACTS = 'SET_CLIENTS_DUE_CONTRACTS';
export const SET_CALL_RESULT_RESPONSE = 'SET_CALL_RESULT_RESPONSE';
export const SET_CALL_RESULT_CREATED_RESPONSE = 'SET_CALL_RESULT_CREATED_RESPONSE';
export const SET_SUMMARY_INFO = 'SET_SUMMARY_INFO';
export const SET_CURRENT_COMPONENT = 'SET_CURRENT_COMPONENT';
export const SET_LATE_DAYS = 'SET_LATE_DAYS';
